import { c as _c } from "react/compiler-runtime";
import { isEmpty } from '@newfront-insurance/core';
import { Input } from '@newfront-insurance/core-ui';
import type { JSX } from 'react';
interface Props {
  onChange: (value?: string) => void;
  disabled?: boolean;
  value?: number;
}
export function PercentageInput(t0) {
  const $ = _c(6);
  const {
    value,
    onChange,
    disabled
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = inputValue => onChange(isEmpty(inputValue) ? undefined : inputValue);
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== disabled || $[3] !== t1 || $[4] !== value) {
    t2 = <Input type="number" value={value} onChange={t1} appendText="%" disabled={disabled} />;
    $[2] = disabled;
    $[3] = t1;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}